import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import updateItemData from "../common/util/updateItemData";

export default class DecorationStoreEquipmentStatusModal extends Modal {
  static isDismissibleViaBackdropClick = false
  static isDismissibleViaCloseButton = true;

  oninit(vnode) {
    super.oninit(vnode);
    const {itemPurchaseData,purchaseStatus} = this.attrs;
    const itemData = itemPurchaseData.decorationData();

    this.itemTitle = itemData.item_title();
    this.itemPurchaseData = itemPurchaseData;
    this.purchaseID = itemPurchaseData.id();
    this.purchaseStatus = purchaseStatus;
    this.loading = false;
  }

  className() {
    return 'Modal--small';
  }

  title() {
    return this.itemTitle;
  }

  content() {
    return [
      <div className="Modal-body">
        <div id="DecorationStoreConfirmationText" className="DecorationStoreConfirmationText">
          {this.purchaseStatus===0 && (
            <div>{app.translator.trans('ziven-decoration-store.forum.item-status-to-0-confirmation')}</div>
          )}
          {this.purchaseStatus===1 && (
            <div>{app.translator.trans('ziven-decoration-store.forum.item-status-to-1-confirmation')}</div>
          )}
        </div>
        <div style="text-align:center">
          {Button.component({
              disabled: this.loading,
              className: 'Button Button--primary',
              onclick: () => {
                this.setItemStatus();
              }
            },
            app.translator.trans('ziven-decoration-store.lib.ok')
          )}&nbsp;
          {Button.component({
              disabled: this.loading,
              className: 'Button decorationButton--gray',
              onclick: () => {
                this.hide();
              }
            },
            app.translator.trans('ziven-decoration-store.lib.cancel')
          )}
        </div>
      </div>,
    ];
  }

  setItemStatus(){
    const purchaseID = this.purchaseID;
    const purchaseStatus = this.purchaseStatus;

    $("#DecorationStoreConfirmationText").text(app.translator.trans('ziven-decoration-store.forum.processing'));

    this.loading = true;
    this.itemPurchaseData
      .save({purchaseID,purchaseStatus})
      .then((payload) => {
        updateItemData(payload);
        app.modal.close();
      });
  }
}